{
  "private": false,
  "name": "@v0xoss/oss-cli",
  "type": "module",
  "license": "MIT",
  "version": "0.0.3",
  "homepage": "https://github.com/vezham/heroui-cli#readme",
  "description": "A CLI tool that unlocks seamless HeroUI integration (Previously NextUI CLI)",
  "keywords": [
    "UI",
    "CLI",
    "Tool",
    "NextUI",
    "Template",
    "Integration",
    "Add Component",
    "HeroUI"
  ],
  "author": "v0xOSS <oss-developers@vezham.com>",
  "repository": {
    "type": "git",
    "url": "https://github.com/vezham/heroui-cli.git"
  },
  "bugs": {
    "url": "https://github.com/vezham/heroui-cli/issues"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "files": [
    "dist"
  ],
  "bin": {
    "heroui": "./dist/index.js"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "scripts": {
    "dev": "tsup --watch",
    "link:cli": "pnpm link --global",
    "link:remove": "pnpm uninstall --global heroui-cli",
    "build": "tsup",
    "update:components": "tsx src/scripts/update/update-components.ts",
    "sync:docs": "tsx src/scripts/sync/sync.ts",
    "clean:cache": "tsx src/scripts/cache/clean.ts",
    "lint": "eslint . --max-warnings=0",
    "lint:fix": "eslint . --max-warnings=0 --fix",
    "check:prettier": "prettier --check .",
    "check:types": "tsc --noEmit",
    "changelog": "npx conventional-changelog -p angular -i CHANGELOG.md -s --commit-path .",
    "release": "bumpp --execute='pnpm run changelog' --all",
    "prepare": "husky install",
    "postbuild": "pnpm run update:components",
    "prepublishOnly": "pnpm run build",
    "v:ws:changeset": "changeset",
    "v:ws:changeset:checklist-release": "bash v/bin/checklist-release/bin/main.sh",
    "v:ws:changeset:update-versions": "bash v/bin/update-versions/bin/main.sh",
    "v:ws:git:cleanup-release": "bash v/bin/cleanup-release/bin/main.sh",
    "v:ws:npm:unpublish": "bash v/bin/npm-unpublish/bin/main.sh"
  },
  "dependencies": {
    "@clack/prompts": "0.7.0",
    "@winches/prompts": "0.0.7",
    "async-retry": "1.3.3",
    "chalk": "5.3.0",
    "commander": "11.0.0",
    "compare-versions": "6.1.1",
    "fast-glob": "3.3.2",
    "find-up": "7.0.0",
    "gradient-string": "2.0.2",
    "ora": "8.0.1",
    "pathe": "1.1.2",
    "tar": "6.2.1"
  },
  "devDependencies": {
    "@changesets/changelog-github": "0.5.0",
    "@changesets/cli": "2.27.10",
    "@changesets/get-github-info": "0.6.0",
    "@changesets/get-release-plan": "4.0.5",
    "@changesets/types": "6.0.0",
    "@commitlint/cli": "17.7.1",
    "@commitlint/config-conventional": "17.7.0",
    "@types/gradient-string": "1.1.3",
    "@types/node": "20.11.30",
    "@typescript-eslint/eslint-plugin": "6.7.2",
    "@typescript-eslint/parser": "6.7.2",
    "bumpp": "9.4.0",
    "clean-package": "2.2.0",
    "commitlint-plugin-function-rules": "2.0.2",
    "conventional-changelog-cli": "4.1.0",
    "eslint": "8.50.0",
    "eslint-config-prettier": "9.0.0",
    "eslint-import-resolver-typescript": "3.6.1",
    "eslint-plugin-import": "2.28.1",
    "eslint-plugin-prettier": "5.0.0",
    "eslint-plugin-sort-destructure-keys": "1.5.0",
    "eslint-plugin-sort-keys-fix": "1.1.2",
    "eslint-plugin-unicorn": "52.0.0",
    "eslint-plugin-unused-imports": "3.0.0",
    "husky": "8.0.3",
    "lint-staged": "14.0.1",
    "prettier": "3.3.2",
    "tsup": "7.2.0",
    "tsx": "4.7.1",
    "typescript": "5.2.2"
  },
  "engines": {
    "pnpm": ">=9.x"
  },
  "packageManager": "pnpm@9.6.0"
}
